module.exports = __webpack_public_path__ + "static/media/auto-logo.9ae5ff04.svg";